import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import CardHeader from '../../../../components/CardHeader';
import { IEventItem } from '../../../../store/player/events/store';

interface IProps {
  item: IEventItem;
}

const EventInfo = ({ item }: IProps) => {
  return (
    <div className="event-info wrapper">
      {item.prices && item.processPayment && (
        <Paper elevation={1} className="paper">
          <CardHeader label="Pricing" />

          <div className="pricing-table">
            <div className="th">
              <div>ENTRY</div>
              <div>FEE</div>
              <div>DEADLINE</div>
            </div>

            {item.prices.map((price, index) => (
              <div className="tr" key={`price-row-${index}`}>
                <div>{price.name}</div>
                <div>${Number(price.price).toFixed(2)}</div>
                <div>{price.end ? moment(price.end).format('MMM DD, YYYY') : '--'}</div>
              </div>
            ))}
          </div>
        </Paper>
      )}

      {item.description && item.description.length && (
        <Paper elevation={1} className="paper">
          <CardHeader label="EVENT DETAILS" />

          <div className="info-content">
            <ReactMarkdown source={item.description} className="markdown" />
          </div>
        </Paper>
      )}
    </div>
  );
};

export { EventInfo };
